import React, { useEffect, useState } from "react";
import TextToVideoIcon from "../../../Custom-imeges/VideoSuite/TextToVideoIcon";
import ImageToVideoIcon from "../../../Custom-imeges/VideoSuite/ImageToVideoIcon";
import { Box } from "@mui/material";
import VideoSuiteSidebar from "../Components/VideoSuiteSidebar";
import VideoSuiteContainer from "../Components/VideoSuiteContainer";
import "./VideoSuite.css";
import {
  useGetVideoSuiteApps,
  userGetVideoSuiteSamples,
} from "../../../store/Apis/SuitesApps/VideoSuiteApi";
import { VideoAppType, VideoSuiteType } from "../../../Types/VideoSuite-Types";
import { AvatarVideoIcon } from "../../../Custom-imeges/VideoSuite/AvatarVideoIcon";
import { useLocation, useNavigate } from "react-router-dom";

const VideoSuite = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const hasRedirectApp = location?.state?.activeVideoAppType;
  const [videoSuiteApps, setVideoApps] = useState<VideoAppType[]>([]);
  const [activeItem, setActiveItem] = useState<VideoAppType>({
    id: "",
    name: "",
    type: 0,
    order: 0,
  });

  const { refetch: GetSamplesVideoSuite, data: videoSuiteSamples } =
    userGetVideoSuiteSamples();
  const { refetch: GetVideoSuiteApps, data: videoSuiteAppsData } =
    useGetVideoSuiteApps();

  useEffect(() => {
    GetSamplesVideoSuite();
    GetVideoSuiteApps();
  }, []);

  useEffect(() => {
    const apps: VideoAppType[] = [];

    videoSuiteAppsData?.forEach((item: VideoAppType) => {
      if (item.type === VideoSuiteType.VideoGenerator) {
        apps.push({
          ...item,
          icon: <TextToVideoIcon className="text-nav-item-icon" />,
        });
      } else if (item.type === VideoSuiteType.ImageToVideo) {
        apps.push({
          ...item,
          icon: <ImageToVideoIcon className="text-nav-item-icon" />,
        });
      } else if (item.type === VideoSuiteType.AvatarVideo) {
        apps.push({
          ...item,
          icon: <AvatarVideoIcon className="text-nav-item-icon" />,
        });
      }
    });

    setVideoApps(apps);
  }, [videoSuiteAppsData]);

  // Set the active item based on the redirect app or first app in the list.
  useEffect(() => {
    if (hasRedirectApp) {
      // If there is a redirect app, set it as active
      handleSetActiveItem(hasRedirectApp);
    } else if (videoSuiteApps.length > 0) {
      // Set first item as active
      setActiveItem(videoSuiteApps[0]);
    }
  }, [videoSuiteApps]);

  const handleSetActiveItem = (name: string) => {
    if (name !== activeItem.name) {
      const appObject = videoSuiteApps.find((app) => app.name === name);
      if (appObject) {
        setActiveItem({ ...appObject });
      }
    }
  };

  return (
    <Box className="image-suites-view">
      <VideoSuiteSidebar
        setActiveItem={handleSetActiveItem}
        activeItem={activeItem}
        VideoSuitesApps={videoSuiteApps}
      />
      {videoSuiteAppsData?.length && (
        <VideoSuiteContainer
          activeItem={activeItem}
          VideoSuiteSamples={videoSuiteSamples}
        />
      )}  
    </Box>
  );
};

export default VideoSuite;
